// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2a5kc","content":"RecentSearches_content__1ckbK"};